import React from 'react'
import { Provider } from 'react-redux'
import Game from './containers/Game'
import ImpersonationControls from './ImpersonationControls'
import store from '../store'
import PixelManager from './PixelManager'
import { PixelProvider } from '../contexts/PixelContext'
import * as ws from '../lib/websocket'

ws.connect()

console.log('websocket connected', ws)

const GameRoot = props => {
  console.log('INITIAL', INITIAL)

  // Check if impersonation is active
  const impersonation = INITIAL.impersonation
  const isImpersonating = impersonation && impersonation.is_impersonating

  // Add CSS class to body for styling adjustments
  React.useEffect(() => {
    if (isImpersonating) {
      document.body.classList.add('has-impersonation-controls')
    }

    return () => {
      document.body.classList.remove('has-impersonation-controls')
    }
  }, [isImpersonating])

  return (
    <Provider store={store}>
      {/* Show impersonation controls if user is impersonating someone */}
      {isImpersonating && (
        <ImpersonationControls
          impersonation={impersonation}
          gameId={INITIAL.game.id}
        />
      )}

      {/* Note: ImpersonationNotification would be shown via WebSocket
          when a user is being impersonated by someone else */}

      <PixelProvider>
        <Game />
        <PixelManager />
      </PixelProvider>
    </Provider>
  )
}

export default GameRoot
